import { COMMA, ENTER, F } from "@angular/cdk/keycodes";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from '@angular/material/snack-bar';
import { timeout } from 'rxjs/operators';
import { TranslateService } from "../../services/translate.service";
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { LogViewerDialogComponent } from '../misc-components/Loger-Viewer/Loger-Viewer.component';
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import * as languageData from '../../services/languages.json';
import { ChangeDetectorRef } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  startWith,
  take,
  throttleTime,
  withLatestFrom
} from "rxjs/operators";
import { NewsService } from "../../services/news.service";
// Update imports to include MatSelectChange
import { MatSelectChange } from '@angular/material/select';


import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { FormControl } from '@angular/forms';
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofType } from "@ngrx/effects";
import { Store, select } from "@ngrx/store";
import { NgxSpinnerService } from "ngx-spinner";
import { NewsLogEntry } from "src/app/models/news-logentry.model";
import { News } from "src/app/models/news.model";
import { Tag } from "src/app/models/tags.model";
import { State } from "src/app/reducers";
import { TagService } from "src/app/services/tag.service";
import {
  selectActive
} from "src/app/selectors/tag.selector";
import { AuthService } from "src/app/services/auth.service";
import { MappingService } from "src/app/services/mapping.service";
import { MiscService } from "src/app/services/misc.service";
import { ScrappingService } from "src/app/services/scrapping.service";
import { TranslationToolsService } from "src/app/services/translationTools.service";
import { v4 as uuidv4 } from "uuid";
import { environment } from "../../../environments/environment";
import {
  addCurrentTag,
  articleSuccess,
  checkItem,
  checkURLDuplicatesOnCreate,
  closeEditorMap,
  confirmItem,
  deleteItem,
  disableCreateButton,
  enableCreateButton,
  genericError,
  genericNotification,
  openEditorMap,
  programmaticArticleUpdate,
  removeCurrentTag,
  requestArticle,
  requestDocumentLanguages,
  resetArticleForm,
  setItem,
  translateDocument,
  translateDocumentFail,
  translateDocumentSuccess,
  translateDocumentSummary,
  translateDocumentSummaryFail,
  translateDocumentSummarySuccess,
  uncheckItem,
  unconfirmItem,
  updateArticle,
  updateEditorMap,
  updateItem
} from "../../actions/news.actions";
import { ChromeService } from "../../services/chrome.service";
import { EditorMapModalWrapperComponent } from "../news-editor/editor-map-modal-wrapper/editor-map-modal-wrapper.component";
import { MatTabGroup } from "@angular/material/tabs";
declare var chrome: any;

interface TagDisplay {
  id: string;
  uid?: number;
  color: string;
}

@UntilDestroy()
@Component({

  selector: "app-editor",
  templateUrl: "./editor.component.html",
  styleUrls: ["./editor.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})



export class EditorComponent implements OnInit, AfterViewChecked, OnDestroy {
  translations: any[] = [];
  isProcessing = false;
  translationServices: any[] = [];
  selectedTranslationService: string;
  private destroy$ = new Subject<void>();
  languagesSource = [
    { name: 'English', iso: 'en' },
    { name: 'German', iso: 'de' },
    { name: 'French', iso: 'fr' },
    // Add more languages here
  ];

  filteredLanguagesSource = [];
  inputFormControl = new FormControl();
  languageSearchControl = new FormControl();
  showSpinnerDe = false; // Variable für den Spinner in Deutsch Translated
  showSpinnerEn = false; // Variable für den Spinner in Englisch Translated
  isTranslating = false; // Boolean flag to track translation state
  public isLoadingMetadata = new BehaviorSubject<boolean>(true);
  public isLoadingTags = new BehaviorSubject<boolean>(true);
  private translationAbortController: AbortController | null = null;
  private processingType: string | null = null;
  isExtracting = false;
  currentExtractRequest: Subscription | null = null;
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;



  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private chromeService: ChromeService,
    public authService: AuthService,
    private store: Store<State>,
    private mappingService: MappingService,
    private tagsService: TagService,
    private miscService: MiscService,
    private actions$: Actions,
    private scrapeService: ScrappingService,
    private newsService: NewsService,
    private translationToolsService: TranslationToolsService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar,
  ) {
    this.isExtension = environment.extension;
  }


  public Editor = ClassicEditor;
  public Editor2 = ClassicEditor;
  public Editor3 = ClassicEditor;

  platforms = [
    { value: "cyber", name: "Cyber" },
    { value: "innotech", name: "Innotech" },
    { value: "krimisi", name: "KriMiSi" },
  ];

  inputForm = new UntypedFormGroup({
    article_source: new UntypedFormControl(),
    article_title: new UntypedFormControl(),
    article_subtitle: new UntypedFormControl(),
    article_content: new UntypedFormControl(""),
    article_author: new UntypedFormControl(),
    article_created_at: new UntypedFormControl(),
    article_language: new UntypedFormControl(),
    article_place: new UntypedFormControl(),
    article_confirmed: new UntypedFormControl(),
    article_checked: new UntypedFormControl(),
    article_platforms: new UntypedFormArray([
      new UntypedFormControl(true),
      new UntypedFormControl(false),
      new UntypedFormControl(false),
    ]),
    lat: new UntypedFormControl({ disabled: true, value: 0 }),
    lon: new UntypedFormControl({ disabled: true, value: 0 }),
    article_summary_native: new UntypedFormControl(),
    article_summary_en: new UntypedFormControl(""),
    article_summary_de: new UntypedFormControl(),
    article_content_translatedde: new UntypedFormControl(""),
    article_title_translatedde: new UntypedFormControl(),
    article_subtitle_translatedde: new UntypedFormControl(),
    article_hashvalue: new UntypedFormControl(),
    article_content_translateden: new UntypedFormControl(""),
    article_title_translateden: new UntypedFormControl(),
    article_subtitle_translateden: new UntypedFormControl(),
    article_translated_with_en: new UntypedFormControl(),
    article_translated_with_de: new UntypedFormControl(),
    translation_service: new UntypedFormControl('')
  });

  get article_platforms() {
    return this.inputForm.get("article_platforms") as UntypedFormArray;
  }

  // Inputs
  isExtension;

  // vars

  newArticle = false;
  tags = [];
  lockTags;
  public maxDate = new Date(new Date().setHours(23, 59, 59));

  // Readonly(won't be saved)
  news;

  filesID;

  // Vars for tags
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  termCtrl = new UntypedFormControl();
  filteredTermsSub: any = new BehaviorSubject([
    {
      id: "Tags Test",
      platform: "cyber",
    },
  ]);

  savedSelection;
  savedSelection2;

  filteredTermsByPlatform: any = [];
  terms = [];
  allTerms = [];
  tagTreeDirty = false;
  ready = false;

  tagBuffer = new Set();
  embedded = false;

  displayPreview = false;
  previewData = null;
  previewWidth = "100";
  previewHeight = "100";
  zoomToggle = false;
  subs = [];
  init = false;

  languages = [];
  languagesDocument = [];

  extractingOrTranslating: boolean = false;

  createButtonDisabled$: Observable<any[]> = this.store.select(
    (state) => state.editorState.createButtonDisabled
  );

  availableTags$: Observable<Tag[]> = this.store.pipe(select(selectActive));
  article$: Observable<News> = this.store.select(
    (state) => state.currentArticle
  );

  permissions$: Observable<any> = this.store.select(
    (state) => state.permissions
  );

  clearSub = new Subject();
  actSub;

  lat = 0;
  lon = 0;

  id;

  displayTags: TagDisplay[] = [];
  rawDetailTags: any[];
  //stringTagsToUID: Map<string, number>;

  articleLogHistory?;

  @Input() isNew = false;

  openMap$ = this.store.select((store) => store.mapSettings.openMap);

  @ViewChild("termInput") termInput: ElementRef;
  @ViewChild("historyPaginator") historyPaginator: MatPaginator;

  gdeltToArray() {
    return Object.entries(this.news)
      .filter(([key, value]) => key.includes("gdelt"))
      .map(([key, value]) => ({ key, value }));
  }
  deleteData() {
    // TODO
    /*
    this.store.dispatch(
      deleteItem({
        id: this.news.id,
      })
    );
    */
  }

  async getTranslationToolservice()
  {
    this.getTranslationTool().subscribe(
      (data: any) => {
        const specificService = data.translationTool;
        console.log('Translation Tool:', specificService);
        if (specificService) {
          this.inputForm.get('translation_service').setValue(specificService);
          // Assign values to the form controls
          this.article$.subscribe((article: any) => {
            article.article_translated_with_de = specificService;
          });
        }
        // Continue with the translation process using specificService
        // ...
      },
      (error: any) => {
        console.error('Error fetching translation tool:', error);

      }
    );
  }
  // Translates for English and German, first in English, then in german.
  async translate() {
    const originalLanguage = this.inputForm.get('article_language').value;
    this.translationAbortController = new AbortController();
    this.checkAndAddTranslationTool("NEURALSEEK");
    this.isTranslating = true;
    this.showSpinnerDe = true;
    this.spinner.show('deSpinner');
    this.showSpinnerEn = true;
    this.spinner.show('enSpinner');

     // Setze die ursprüngliche Sprache zurück


    /*this.translate_en().finally(() => {
      this.translate_de()});*/
      try {
        await this.translate_en('en', this.translationAbortController.signal);
        await this.translate_de('de', this.translationAbortController.signal);

      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Translation cancelled');
        } else {
          console.error('Translation error:', error);
        }
      } finally {
        this.translationAbortController = null;
      }

    this.isTranslating = false;
  }

  async cancelProcessing(type: string) {
    if (this.translationAbortController) {
      this.translationAbortController.abort();
      this.translationAbortController = null;
    }

    switch(type) {
      case 'de':
        this.showSpinnerDe = false;
        this.spinner.hide('deSpinner');
        break;
      case 'en':
        this.showSpinnerEn = false;
        this.spinner.hide('enSpinner');
        break;
      case 'editor':
        this.spinner.hide('editorSpinner');
        this.isProcessing = false;
        break;
      case 'extract':
        this.isExtracting = false;
        this.spinner.hide('extractSpinner');
        // Cancel any ongoing extract operations
        if (this.currentExtractRequest) {
          this.currentExtractRequest.unsubscribe();
        }
        break;
    }

    this.isTranslating = false;

    // Show cancellation notification
    this.snackBar.open('Process cancelled', 'Close', {
      duration: 3000,
      horizontalPosition: 'end',
      verticalPosition: 'top'
    });
  }

  public getTranslationTool(): Observable<any> {
    const language = this.http.get<any>(`${environment.SERVER_URL}/translations/translationTool`);
    //console.log("Translation Tool:", language);
    return language;
  }



  async translate_en(targetLang: string, signal?: AbortSignal): Promise<void> {
    return new Promise((resolve, reject) => {
      const originalLanguage = this.inputForm.get('article_language').value;
      this.showSpinnerEn = true;
      this.spinner.show('enSpinner');
      this.translations = [];

      // Create observable with timeout
      const translation$ = this.actions$.pipe(
        ofType(translateDocumentSuccess, translateDocumentFail),
        take(1),
        // Add timeout of 30 seconds
        timeout(30000)
      );

      // Handle abort signal
      if (signal) {
        signal.addEventListener('abort', () => {
          reject(new Error('Translation cancelled'));
        });
      }

      // Dispatch translation action
      this.store.dispatch(translateDocument({ language: "en" }));

      // Subscribe to translation result
      translation$.subscribe({
        next: (action: any) => {
          if (action.type === '[Editor Component] Translate current document success') {
            this.translations.push(action);
            // Restore original language
            this.inputForm.patchValue({
              article_language: originalLanguage
            }, { emitEvent: false });

            this.spinner.hide('enSpinner');
            this.showSpinnerEn = false;
            this.getTranslationToolservice();
            this.displayTranslations();
            resolve();
          } else {
            reject(new Error('Translation failed'));
          }
        },
        error: (error) => {
          this.spinner.hide('enSpinner');
          this.showSpinnerEn = false;
          reject(error);
        }
      });
    });
  }

  async translate_de(targetLang: string, signal?: AbortSignal): Promise<void> {
    return new Promise((resolve, reject) => {
      const originalLanguage = this.inputForm.get('article_language').value;
      this.showSpinnerDe = true;
      this.spinner.show('deSpinner');
      this.translations = [];

      // Create observable with timeout
      const translation$ = this.actions$.pipe(
        ofType(translateDocumentSuccess, translateDocumentFail),
        take(1),
        // Add timeout of 30 seconds
        timeout(30000)
      );

      // Handle abort signal
      if (signal) {
        signal.addEventListener('abort', () => {
          reject(new Error('Translation cancelled'));
        });
      }

      // Dispatch translation action
      this.store.dispatch(translateDocument({ language: "de" }));

      // Subscribe to translation result
      translation$.subscribe({
        next: (action: any) => {
          if (action.type === '[Editor Component] Translate current document success') {
            this.translations.push(action);
            // Restore original language
            this.inputForm.patchValue({
              article_language: originalLanguage
            }, { emitEvent: false });

            this.spinner.hide('deSpinner');
            this.showSpinnerDe = false;
            this.getTranslationToolservice();
            this.displayTranslations();
            resolve();
          } else {
            reject(new Error('Translation failed'));
          }
        },
        error: (error) => {
          this.spinner.hide('deSpinner');
          this.showSpinnerDe = false;
          reject(error);
        }
      });
    });
  }
  async translateSummary(sourceLang: string, targetLang: string): Promise<void> {
  return new Promise((resolve, reject) => {
    this.isTranslating = true;
    this.spinner.show('editorSpinner');

    const summaryControlName = `article_summary_${sourceLang}`;
    const targetSummaryControlName = `article_summary_${targetLang}`;
    const summaryControl = this.inputForm.get(summaryControlName);

    if(targetLang == "native")
    {
      targetLang = this.inputForm.get("article_language").value;
    }

    if (!summaryControl) {
      console.error(`Form control ${summaryControlName} does not exist.`);
      this.isTranslating = false;
      this.spinner.hide('editorSpinner');
      reject(`Form control ${summaryControlName} does not exist.`);
      return;
    }

    const summaryContent = summaryControl.value;

    if (!summaryContent) {
      console.error(`Form control ${summaryControlName} has no value.`);
      this.isTranslating = false;
      this.spinner.hide('editorSpinner');
      reject(`Form control ${summaryControlName} has no value.`);
      return;
    }

    this.store.dispatch(translateDocumentSummary({ language: targetLang, content: summaryContent }));

    this.actions$
      .pipe(
        ofType(translateDocumentSummarySuccess, translateDocumentSummaryFail),
        take(1)
      )
      .subscribe((action: any) => {
        if (action.type === '[Editor Component] Translate current document summary success') {
          this.inputForm.get(targetSummaryControlName).setValue(action.content);
        } else {
          console.error('Translation failed:', action.error);
        }
        this.isTranslating = false;
        this.spinner.hide('editorSpinner');
        resolve();
      });
  });
}


  async checkAndAddTranslationTool(toolName: string) {
    try {
      // Wait for the first operation to complete
      const exists = await this.translationToolsService
        .getTranslationServicesCreateIfNotExisiting(toolName)
        .toPromise();

      if (!exists) {
        console.log(`Translation tool ${toolName} added successfully`);
      } else {
        console.log('Translation tool already exists');
      }

      // Only proceed after first operation is complete
      await this.getTranslationToolservice();
    } catch (error) {
      console.error('Error in translation tool operation:', error);
    }
  }
  displayTranslations() {
    // Logic to display translations
    console.log('Translations:', this.translations);
  }

  onCKReady(editor) {
    // CKEDITOR hack that saves the carret position on new data
    const style = document.createElement('style');
    style.textContent = '.ck.ck-powered-by { display: none !important; }';
    document.head.appendChild(style);

    editor.ui.view.toolbar.element.style.padding = '0';
    const poweredBy = editor.ui.view.element.querySelector('.ck-powered-by');
    if (poweredBy) {
      poweredBy.remove();
    }
    editor.editing.view.change(writer => {
      writer.setStyle(
        'min-height',
        '300px',
        editor.editing.view.document.getRoot()
      );
    });
    editor.model.document.on("change:data", (change) => {
      const selection = editor.model.document.selection.getFirstPosition();
      if (!(selection.path[0] == 0 && selection.path[1] == 0)) {
        this.savedSelection = selection;
      } else if (this.savedSelection) {
        editor.model.change((writer) => {
          if ((this.savedSelection, editor.getData())) {
            const pos = writer.createPositionFromPath(
              editor.model.document.getRoot(),
              this.savedSelection.path
            );

            // Check if path is valid
            try {
              const pa = [...pos.path];
              let el = pa.shift();
              let head = editor.model.document.getRoot();

              while (el != undefined) {
                if (head._children) {
                  const index = head.offsetToIndex(el);
                  head = [...head.getChildren()][index];
                }
                el = pa.shift();
              }
            } catch (e) {
              return;
            }

            // Only if path is valid set it
            try {
              writer.setSelection(pos);
            } catch (e) {
              console.log("myerror", e);
            }
          }
        });
      }
    });
  }

  onCKReady2(editor) {
    // CKEDITOR hack that saves the carret position on new data
    const poweredBy = editor.ui.view.element.querySelector('.ck-powered-by');
    const style = document.createElement('style');
    style.textContent = '.ck.ck-powered-by { display: none !important; }';
    document.head.appendChild(style);

    if (poweredBy) {
      poweredBy.remove();
    }
    editor.editing.view.change(writer => {
      writer.setStyle(
        'min-height',
        '300px',
        editor.editing.view.document.getRoot()
      );
    });
    editor.model.document.on("change:data", (change) => {
      const selection = editor.model.document.selection.getFirstPosition();
      editor.ui.view.toolbar.element.style.padding = '0';

      if (!(selection.path[0] == 0 && selection.path[1] == 0)) {
        this.savedSelection2 = selection;
      } else if (this.savedSelection2) {
        editor.model.change((writer) => {
          if ((this.savedSelection2, editor.getData())) {
            const pos = writer.createPositionFromPath(
              editor.model.document.getRoot(),
              this.savedSelection2.path
            );

            // Check if path is valid
            try {
              const pa = [...pos.path];
              let el = pa.shift();
              let head = editor.model.document.getRoot();

              while (el != undefined) {
                if (head._children) {
                  const index = head.offsetToIndex(el);
                  head = [...head.getChildren()][index];
                }
                el = pa.shift();
              }
            } catch (e) {
              return;
            }

            // Only if path is valid set it
            try {
              writer.setSelection(pos);
            } catch (e) {
              console.log("myerror", e);
            }
          }
        });
      }
    });
  }

  ngOnInit() {
    this.tagsService.tags$.subscribe(tags => {
      if (tags?.length) {
        //console.log('Received tags in component:', tags);
        this.allTerms = tags;
        // ...rest of your tag handling code
      }
    });
    this.store.dispatch(resetArticleForm());
    this.ready = true;
    this.languagesSource = Object.entries(languageData).map(([iso, name]) => ({
      iso: iso,
      name: name
    }));


    // Initialisieren Sie die gefilterten Sprachen
    this.filteredLanguagesSource = [...this.languagesSource];



      this.translationToolsService.getTranslationServices().subscribe((services) => {
        this.translationServices = services;
      });

      this.translationToolsService.getTranslationServices().subscribe((services) => {
        this.translationServices = services;
      });

    this.isExtension = environment.extension;
    this.actSub = this.activatedRoute.params
      .pipe(untilDestroyed(this))
      .subscribe((params) => {
        //console.log("router", params);
        if (params.id == "new") {
          // this.resetForm();
          this.newArticle = true;
          this.store.dispatch(resetArticleForm());
        } else if (params.id) {
          this.newArticle = false;
          //console.log("i am requesting");
          this.store.dispatch(
            requestArticle({
              id: params.id,
            })
          );
          this.id = params.id;
        } else {
          this.newArticle = this.isNew;
          this.embedded = true;
          //console.log("here we go again");
        }
      });

    // Initialize the store when new data is arriving
    this.article$
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        withLatestFrom(this.store.select("defaultPlattform")),
        withLatestFrom(this.store.select("tagMapping"))
      )
      .subscribe(([[article, plattform], tagMap]) => {
        //console.log("article", article);
        let {
          article_checked,
          article_confirmed,
          article_author,
          article_content,
          article_subtitle,
          article_title,
          article_source,
          article_created_at,
          article_language,
          article_languageErfassung,
          article_place,
          article_platforms,
          article_geolocation,
          article_filesID,
          article_content_translatedde,
          article_title_translatedde,
          article_summary,
          article_summary_translateden,
          article_summary_translatedde,
          article_subtitle_translatedde,
          article_content_translateden,
          article_title_translateden,
          article_subtitle_translateden,
          article_translated_with_de,
          article_translated_with_en,
          article_log,
          article_tags,
        } = article;

        this.filesID = article_filesID;
        //Generate new fileID if not exisitng
        if (!article_filesID) {
          this.filesID = article_filesID || uuidv4();
          this.store.dispatch(
            programmaticArticleUpdate({
              ...(article as any),
              article_filesID: this.filesID,
            })
          );
        }

        article_language = article_language || "en";
        article_languageErfassung = article_languageErfassung || "en";
        article_place = article_place || "";

        //  if((!article_platforms || article_platforms.length==0)&&!(article as any).id){
        // TODO move to effects
        article_platforms = ["cyber", "innotech", "krimisi"];
        // this.store.dispatch(programmaticArticleUpdate({...article as any,article_platforms}))
        // }

        if (article_log) {
          this.articleLogHistory = new MatTableDataSource<NewsLogEntry>(
            [...article_log].reverse()
          );
          if (this.historyPaginator) {
            this.articleLogHistory.paginator = this.historyPaginator;
          }
        } else {
          this.articleLogHistory = undefined;
        }

        if (article_checked) {
          this.inputForm.disable({ onlySelf: false, emitEvent: false });
          this.inputForm.controls.article_checked.enable({
            onlySelf: false,
            emitEvent: false,
          });
          this.inputForm.controls.article_confirmed.enable({
            onlySelf: false,
            emitEvent: false,
          });
          this.store.dispatch(disableCreateButton());
        } else {
          this.inputForm.enable({ onlySelf: false, emitEvent: false });
          if (!article_confirmed)
            this.inputForm.controls.article_confirmed.disable({
              onlySelf: false,
              emitEvent: false,
            });
          this.store.dispatch(enableCreateButton());
        }

        // Beginn TAG UID to String ID handling.
        try {
          this.rawDetailTags = [];
          article_tags.forEach((uid) => {
            let ret = tagMap.get(uid);
            if (ret) this.rawDetailTags.push(ret);
          });

          // Copy to prevent sorting of source object.
          let sorti = [...this.rawDetailTags].sort((x, y) => {
            let sX = x.id.split("\t");
            let sY = y.id.split("\t");
            let lastI = Math.min(sX.length, sY.length);

            let equals = true;
            for (let i = 0; i < lastI - 1; i++) {
              if (sX[i] != sY[i]) {
                equals = false;
                break;
              }
            }

            if (equals) return sX.length - sY.length;
            else return x.id.localeCompare(y.id);
          });

          let all_seperate_tags = new Set<TagDisplay>();
          for (let tag of sorti) {
            let current = "";
            let uid = tag.uid;
            for (let part of tag.id.split("\t")) {
              current += part;
              if (!part.startsWith("Tag")) {
                if (current == tag.id) {
                  all_seperate_tags.add({
                    id: current,
                    uid: uid,
                    color: this.getTagPreviewColor(tag, tagMap),
                  });
                } else {
                  all_seperate_tags.add({ id: current, color: "" });
                }
              }
              current += "\t";
            }
          }
          this.displayTags = Array.from(all_seperate_tags).filter(
            (value: TagDisplay, index: number, self: TagDisplay[]) => {
              let found = index === self.findIndex((t: TagDisplay) => t.id === value.id && t.uid);
              if (found) return true;
              return index === self.findIndex((t: TagDisplay) => t.id === value.id);
            }
          );
          //console.log(this.displayTags);
        } catch (err) {
          console.warn(err);
        }
        // End TAG Handling

        const hasCyber = article_platforms.includes("cyber");
        const hasInnotech = article_platforms.includes("innotech");
        const hasKrimisi = article_platforms.includes("krimisi");

        const article_platforms_bools = [hasCyber, hasInnotech, hasKrimisi];

        const lat = article_geolocation.lat ?? 0;
        const lon = article_geolocation.lon ?? 0;

        this.news = article;
        this.id = this.news.id;
        this.inputForm.patchValue(
          {
            article_author,
            article_content,
            article_subtitle,
            article_title,
            article_source,
            article_created_at,
            article_language,
            article_languageErfassung,
            article_place,
            article_checked,
            article_confirmed,
            article_platforms: article_platforms_bools,
            lat,
            lon,
            article_content_translateden: article_content_translateden || "",
            article_title_translateden: article_title_translateden,
            article_subtitle_translateden: article_subtitle_translateden,
            article_content_translatedde: article_content_translatedde || "",
            article_summary: article_summary || "",
            article_summary_translateden: article_summary_translateden || "",
            article_summary_translatedde: article_summary_translatedde || "",
            article_title_translatedde: article_title_translatedde,
            article_subtitle_translatedde: article_subtitle_translatedde,
            article_translated_with_en: article_translated_with_en,
            article_translated_with_de: article_translated_with_de,

          },
          { emitEvent: false }
        );
      });

    // Update form when geo event
    this.actions$.pipe(ofType(updateEditorMap)).subscribe((data) => {
      // this.inputForm.patchValue(,{emitEvent:false})
      this.store.dispatch(
        programmaticArticleUpdate({
          article_geolocation: { lat: data.lat, lon: data.lon },
          article_place: data.place,
        } as any)
      );
      //
    });

    this.actions$.pipe(ofType(articleSuccess)).subscribe((data) => {
      this.savedSelection = null;
    });

    // Update store when the form is changed
    this.inputForm.valueChanges
      .pipe(untilDestroyed(this), debounceTime(250), distinctUntilChanged())
      .subscribe((data: News) => {
        //include uploaded files

        data.article_filesID = this.filesID;

        this.store.dispatch(updateArticle(data));
      });

    /* this.chromeService.onMessage.subscribe((value) => {
      console.log("Observer value", value);
      this.receiveMessage(value);
    });
    this.chromeService.loadExtensionConnection();*/

    // load tags


    this.availableTags$
    .pipe(
      filter((arr) => arr.length > 0),
      take(1)
    )
    .subscribe((data: any) => {
      //console.log("Received tags data:", data); // Debug logging
      this.allTerms = data.map((d) => d);
      //console.log("Processed allTerms:", this.allTerms); // Debug logging

      // Setup für Tag-Filterung
      this.termCtrl.valueChanges
        .pipe(
          startWith(null),
          map((term: string | null) => {
            //console.log("Filtering for term:", term); // Debug logging
            return typeof term === "string" ? this._filter(term) : this.allTerms;
          }),
          throttleTime(100, undefined, { leading: false, trailing: true })
        )
        .subscribe((filtered) => {
          //console.log("Filtered terms:", filtered); // Debug logging
          this.filteredTermsSub.next(filtered);
        });

      // Setup Platform Filter
      this.filteredTermsByPlatform = [
        {
          name: "general",
          observable: this.filteredTermsSub.pipe(
            map((el: any) => {
              //console.log("Filtering general tags:", el); // Debug logging
              return el.filter(e =>
                e.type != "innotech" &&
                e.type != "cyber" &&
                e.type != "krimisi"
              )
            })
          )
        },
          {
            name: "cyber",
            observable: this.filteredTermsSub.pipe(
              map((el: any) => el.filter((e) => e.type == "cyber")),
              map((element: any) => element)
            ),
          },
          {
            name: "krimisi",
            observable: this.filteredTermsSub.pipe(
              map((el: any) => el.filter((e) => e.type == "krimisi")),
              map((element: any) => element)
            ),
          },
          {
            name: "innotech",
            observable: this.filteredTermsSub.pipe(
              map((el: any) => el.filter((e) => e.type == "innotech")),
              map((element: any) => element)
            ),
          },
        ];
      });
    // Standard platform = cyber //TODO

    this.chromeService.loadExtensionConnection();
    //console.log("ed-------------", this.Editor);

    this.subs.push(
      this.openMap$.subscribe((data) => {
        if (!data) return;
        //console.log("map open?", data);
        const dialogRef = this.dialog.open(EditorMapModalWrapperComponent);

        dialogRef.afterClosed().subscribe((result) => {
          //close dialog ref
          if (result) {
            this.store.dispatch(updateEditorMap(result));
          }
          this.store.dispatch(closeEditorMap());
        });
      })
    );
  }
  ngOnDestroy() {
    // this.tagSub.unsubscribe();
    this.actSub.unsubscribe();
    this.subs.forEach((e) => e.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }



  extractData() {
    this.chromeService.extractData();
  }

  displayFn(language: any): string {
    return language ? `${language.name} (${language.iso})` : '';
  }
  onLanguageSourceKey(input: string) {
    //console.log('Filtering languages:', input); // Debug log
    const searchTerm = (input || '').toLowerCase().trim();

    // Direkte Filterung der angezeigten Sprachen
    this.filteredLanguagesSource = [...this.languagesSource].filter(language => {
      if (!searchTerm) return true;

      return language.name.toLowerCase().includes(searchTerm) ||
             language.iso.toLowerCase().includes(searchTerm);
    });
    this.filteredLanguagesSource = this.languagesSource.filter(language =>
      language.name.toLowerCase().includes(input.toLowerCase())
    );
  }
  onLanguageSelected(event: MatSelectChange) {
    const selectedLanguage = this.languagesSource.find(lang => lang.iso === event.value);
    if (selectedLanguage) {
      this.languageSearchControl.setValue(selectedLanguage.name);
    }
  }

  onLanguageDocumentKey(input: string) {
    if (!input) {
      this.languagesDocument = [...this.languages];
      return;
    }

    const searchTerm = input.toLowerCase().trim();

    this.languagesDocument = this.languages.filter(lang =>
      lang.languageDocument &&
      (lang.name.toLowerCase().startsWith(searchTerm) ||
      lang.iso.toLowerCase().startsWith(searchTerm)
    ));
  }


  async checkURLDuplicates() {
    if (this.inputForm.controls.article_source.value && this.isNew) {
      this.store.dispatch(
        checkURLDuplicatesOnCreate({
          url: this.inputForm.controls.article_source.value,
        })
      );
      try {
        let url = this.inputForm.controls.article_source.value;
        var domain: any = new URL(url);
        this.store.dispatch(
          programmaticArticleUpdate({
            ...this.news,
            article_domain: domain.hostname,
          })
        );
      } catch (e) {
        console.log("ERR: ", e);
        this.store.dispatch(
          genericError({ error: "Please provide a valid source URL." })
        );
      }
    }
  }

  reduceHtml(txt: string){
    let value = txt;
    value = txt
            .replaceAll(/id=\"[^\"]*\"/g,"")
            .replaceAll(/class=\"[^\"]*\"/g,"")
            .replaceAll(/<\/?div[ ]*>/g,"")
            .replaceAll("\n","")
            .replaceAll(/>\s+</g, '><')
            .replaceAll(/>\s+/g, '>')
            .replaceAll(/\s+</g, '<');
    return value;
  }

  async serverSideExtract(det: any) {
    this.isExtracting = true;
    this.spinner.show('extractSpinner');

    try {
      if (this.news.article_source && this.news.article_source.length > 0) {
        const url = this.news.article_source;
        try {
          var domain: any = new URL(url);
        } catch (e) {
          genericNotification({
            info: `Invalid url`,
          });
          return;
        }

        domain = domain.hostname;
        this.store.dispatch(
          genericNotification({
            info: `Attempt serverside extract for url: ${this.news.article_source}`,
          })
        );
        this.spinner.show();
        try {
          let res = (await this.scrapeService.scrape({
            url: url,
            news: true,
            html: false,
            ...det,
          })) as any;
          let date = new Date(res.publishing_date);
          let data: any = {
            article_author:
              (res.authors == null || res.authors.length < 1) ? "Autor ungenannt" : res.authors.join(", "),
            article_source: url,
            article_domain: domain,
            article_content:
              res.content_formatted !== null &&
              res.content_formatted !== "" &&
              res.content_formatted !== '<body id="readabilityBody"></body>'
                ? this.reduceHtml(res.content_formatted)
                : res.content,
            article_title: res.title,
            article_subtitle: res.subtitle,
            article_created_at: new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString(),
            article_language: res.language,
          };
          // Change HTML to true to fill content_raw
          if (!res.publishing_date) {
            let currentDate = new Date();
            currentDate.setUTCHours(0, 0, 0, 0);
            data.article_created_at = currentDate.toISOString();
            this.store.dispatch(
              genericError({
                error: "No date can be extracted, using current date!",
              })
            );
          }
          this.spinner.hide();
          this.store.dispatch(programmaticArticleUpdate(data));
        } catch (e) {
          this.spinner.hide();
          if (e.status == 401) {
            this.store.dispatch(genericError({ error: "Not logged in!" }));
            window.open(
              "https://news.zentdok.at/#/login?closeAfterLogin=true",
              "_blank",
              "popup width=800 height=700"
            );
          }
          this.store.dispatch(
            genericError({
              error: `Serverside scrapper failed\n${e.message}`,
            })
          );
        }
      } else {
        this.store.dispatch(
          genericError({
            error: `No url found, please enter a url first!`,
          })
        );
      }
    } catch (e) {
      // Your existing error handling...
    } finally {
      this.isExtracting = false;
      this.spinner.hide('extractSpinner');
      this.currentExtractRequest = null;
    }
  }
  private generateHash(content: string): string {
    let hash = 0;
    if (content.length === 0) return hash.toString();

    for (let i = 0; i < content.length; i++) {
      const char = content.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }

    return Math.abs(hash).toString(16); // Convert to hex string
  }
  updateData(isNew) {
    try {
      let url = this.news.article_source;
      var domain: any = new URL(url);
      let article_content = this.news.article_content;
      const contentToHash = `${this.news.article_title}${this.news.article_content}${this.news.article_source}${this.news.article_created_at}${this.news.article_author}${this.news.article_place}${this.news.article_subtitle}${this.news.article_language}${this.news.article_platforms}${this.news.lat}${this.news.lon}${this.news.article_content_translatedde}${this.news.article_title_translatedde}${this.news.article_subtitle_translatedde}${this.news.article_content_translateden}${this.news.article_title_translateden}${this.news.article_subtitle_translateden}${this.news.article_translated_with_de}${this.news.article_translated_with_en}${this.news.article_summary_translateden}${this.news.article_summary_translatedde}${this.news.article_summary}`;
      const hashValue = this.generateHash(contentToHash);

      if (article_content) {
        article_content = article_content.replace(
          /(<p[^>]*>(?:\s|&nbsp;)*<\/p[^>]*>)+/g,
          "<p></p>"
        );
      }

      // Check if important fields are not empty
      // Source can never be emtpy but for good practice we double check
    if (!this.news.article_content || !this.news.article_title || !this.news.article_source ) {
      this.store.dispatch(
        genericError({ error: "Translated fields in Native Language must not be empty. (Content - Title - Source)" })
      );
      return;
    }
      // Source can never be emtpy but for good practice we double check
    if (!this.news.article_content_translateden || !this.news.article_title_translateden || !this.news.article_source ) {
      this.store.dispatch(
        genericError({ error: "Translated fields in English must not be empty. (Content - Title - Source)" })
      );
      return;
    }
    // Source can never be emtpy but for good practice we double check
    if (!this.news.article_content_translatedde || !this.news.article_title_translatedde || !this.news.article_source ) {
      this.store.dispatch(
        genericError({ error: "Translated fields in German must not be empty. (Content - Title - Source)" })
      );
      return;
    }
    // Check if tags are set
    if (!this.news.article_tags || this.news.article_tags.length === 0) {
      this.store.dispatch(
        genericError({ error: "Set tags before saving" })
      );
      return;
    }

      //console.log("NEWS: ", this.news);
      this.store.dispatch(
        programmaticArticleUpdate({
          ...this.news,
          article_domain: domain.hostname,
          article_content: article_content,
          article_hashvalue: hashValue
        })
      );

      if(this.inputForm.get("article_summary_native").value != null)
      {
        this.store.dispatch(
          programmaticArticleUpdate({
            ...this.news,
            article_summary: this.inputForm.get("article_summary_native").value
          })
        );
      }

      if(this.inputForm.get("article_summary_en").value != null)
        {
          this.store.dispatch(
            programmaticArticleUpdate({
              ...this.news,
              article_summary_translateden: this.inputForm.get("article_summary_en").value
            })
          );
        }

      if(this.inputForm.get("article_summary_de").value != null)
          {
            this.store.dispatch(
              programmaticArticleUpdate({
                ...this.news,
                article_summary_translatedde: this.inputForm.get("article_summary_de").value
              })
            );
          }

    } catch (e) {
      console.log("ERR: ", e);
      this.store.dispatch(
        genericError({ error: "Please provide a valid source URL." })
      );
      return;
    }

    if (
      new Date(this.inputForm.controls.article_created_at.value).setHours(
        0,
        0,
        0
      ) > new Date().setHours(23, 59, 59)
    ) {
      console.log(
        new Date(this.inputForm.controls.article_created_at.value).setHours(
          0,
          0,
          0
        ),
        new Date().setHours(23, 59, 59)
      );
      this.store.dispatch(
        genericError({
          error: "Article date is not allowed to be greater than current day.",
        })
      );
      return;
    }

    if (isNew) this.store.dispatch(disableCreateButton());
    this.store.dispatch(updateItem());
    this.clearSub.next(null);
    this.tabGroup.selectedIndex = 0
  }

  resetForm() {
    // TODO
  }

  containsTagById(list, tagId) {
    return list.some((e) => e.id === tagId);
  }
// Add these methods to your component class
setCurrentDate() {
  this.inputForm.patchValue({
    article_created_at: new Date()
  });
}

setUnknownAuthor() {
  this.inputForm.patchValue({
    article_author: 'Autor ungenannt'
  });
}
  getTagPreviewColor(tag, tagMap) {
    if (!tag) return "#cddc39";

    if (tag.color && (tag.color.startsWith("#") || tag.color.startsWith("r"))) {
      return tag.color;
    } else {
      return this.getTagPreviewColor(tagMap.get(tag.parent), tagMap);
    }
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();

    /*

    console.log("filter", filterValue);
    let firstFilter = this.allTerms.filter(
      (e) =>
        e.permission == this.authService.permission ||
        this.authService.permission == "admin"
    );
    // .filter((d) => this.news.article.platform.includes(d.type.trim()));
*/

    let resort = () => {
      function areArgsValid(mainString, targetStrings) {
        if (typeof mainString !== "string") return false;
        if (!Array.isArray(targetStrings)) return false;
        if (!targetStrings.length) return false;
        if (
          targetStrings.find(function (s) {
            return typeof s !== "string";
          })
        )
          return false;
        return true;
      }

      function compareTwoStrings(first, second) {
        first = first.replace(/\s+/g, "");
        second = second.replace(/\s+/g, "");

        if (first === second) return 1; // identical or empty
        if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

        let firstBigrams = new Map();
        for (let i = 0; i < first.length - 1; i++) {
          const bigram = first.substring(i, i + 2);
          const count = firstBigrams.has(bigram)
            ? firstBigrams.get(bigram) + 1
            : 1;

          firstBigrams.set(bigram, count);
        }

        let intersectionSize = 0;
        for (let i = 0; i < second.length - 1; i++) {
          const bigram = second.substring(i, i + 2);
          const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;

          if (count > 0) {
            firstBigrams.set(bigram, count - 1);
            intersectionSize++;
          }
        }

        return (2.0 * intersectionSize) / (first.length + second.length - 2);
      }

      return (arr, str) => {
        return arr.sort((a, b) => {
          let tagA = a.id
            .substring(a.id.lastIndexOf("\t"), a.id.length)
            .toLowerCase();
          let tagB = b.id
            .substring(b.id.lastIndexOf("\t"), b.id.length)
            .toLowerCase();

          let numTagA = compareTwoStrings(tagA, str);
          let numTagB = compareTwoStrings(tagB, str);

          let delta = numTagB - numTagA;

          if (delta < 0) {
            return -1;
          } else {
            return 1;
          }
        });
      };
    };
    //*/

    let filtered = this.allTerms.filter(
      (fruit) =>
        fruit.id.toLowerCase().indexOf(filterValue) > -1 &&
        !this.rawDetailTags.some((e) => e.id === fruit.id)
    );

    filtered = resort()(filtered, filterValue);

    return filtered;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    console.log(input, value);

    this.termCtrl.setValue(null);
  }
  remove(fruit: string): void {
    const index = this.terms.map((x) => x.content).indexOf(fruit);

    if (index >= 0) {
      this.terms.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const cur = "";
    // this.news.tags.push(event.option.value);
    this.store.dispatch(
      addCurrentTag({ id: parseInt(event.option.value + "", 10) })
    );

    this.termInput.nativeElement.value = "";
    this.termCtrl.setValue(null);
  }
  deleteTag(tag) {
    this.store.dispatch(removeCurrentTag({ id: parseInt(tag + "", 10) }));
  }

  openTab() {
    window.open(this.news.article_source, "_blank");
  }
  saveTags(tags) {
    this.tags = tags;
    this.tagTreeDirty = true;
    this.lockTags = true;
  }

  ngAfterViewInit() {
    // Use requestAnimationFrame to batch DOM updates
    requestAnimationFrame(() => {
      this.isLoadingMetadata.next(false);
      this.isLoadingTags.next(false);
      this.cdr.detectChanges();
    });
  }
  ngAfterViewChecked() {
    this.lockTags = false;
  }
  openMap() {
    this.store.dispatch(openEditorMap());
  }

  async onCheck(event) {
    this.isProcessing = true; // Start processing
    this.spinner.show('editorSpinner'); // Show spinner
    if (event.checked) {
      // Generate current hash from content
      const contentToHash = `${this.news.article_title}${this.news.article_content}${this.news.article_source}${this.news.article_created_at}${this.news.article_author}${this.news.article_place}${this.news.article_subtitle}${this.news.article_language}${this.news.article_platforms}${this.news.lat}${this.news.lon}${this.news.article_content_translatedde}${this.news.article_title_translatedde}${this.news.article_subtitle_translatedde}${this.news.article_content_translateden}${this.news.article_title_translateden}${this.news.article_subtitle_translateden}${this.news.article_translated_with_de}${this.news.article_translated_with_en}${this.news.article_summary_translateden}${this.news.article_summary_translatedde}${this.news.article_summary}`;
      const currentHash = this.generateHash(contentToHash);
      const storehash = this.news.article_hashvalue;
      //console.log('Current hash:', currentHash);
      //console.log('Stored hash:', storehash);
      if (storehash != currentHash) {
        const dialogRef = this.dialog.open(SaveTranslateDialogComponent, {
          width: '300px',
          disableClose: false,
          data: {
            title: 'Content Changed',
            message: 'Content has changed. Do you want to save and/or translate before checking?',
            confirmButton: 'Yes',
            cancelButton: 'No'
          }
        });

        dialogRef.afterClosed().subscribe(async result => {
          switch(result) {
            case 'saveAndTranslate':
              await this.translate();
              await this.updateAndCheck(currentHash);
              this.spinner.hide('editorSpinner');
              break;
            case 'saveOnly':
              await this.updateAndCheck(currentHash);
              this.spinner.hide('editorSpinner');
              break;
            default:
              this.inputForm.controls.article_checked.setValue(false);
          }
        });
      } else {
        await this.updateAndCheck(currentHash);
        this.inputForm.controls.article_checked.setValue(true); // Ensure the item is checked
        this.isProcessing = false; // End processing
        this.spinner.hide('editorSpinner');
      }
    } else {
      // Store current hash before unchecking
      const hashValue = this.news.article_hashvalue;

      // Dispatch uncheck with preserved hash
      this.store.dispatch(
        programmaticArticleUpdate({
          ...this.news,
          article_hashvalue: hashValue, // Preserve hash
          article_checked: false // Uncheck the item
        })
      );

      this.store.dispatch(uncheckItem({ id: this.id }));
      this.inputForm.enable();
      if (!this.inputForm.controls.article_confirmed.value) {
        this.inputForm.controls.article_confirmed.disable();
      }

      // Wait for 5 seconds before calling updateData
      setTimeout(() => {
        this.updateData(this.news);
        this.spinner.hide('editorSpinner');
        this.isProcessing = false; // End processing
      }, 5000);
    }
  }


  private async updateAndCheck(hashValue: string) {
    // First update the hash and content
    await this.store.dispatch(
      programmaticArticleUpdate({
        ...this.news,
        article_hashvalue: hashValue
      })
    );


    // Then check the item
    await this.store.dispatch(checkItem({ id: this.id }));
    await this.inputForm.disable();
    await this.inputForm.controls.article_checked.enable();
    await this.inputForm.controls.article_confirmed.enable();

  }


  onConfirm(event) {
    if (event.checked) this.store.dispatch(confirmItem({ id: this.id }));
    else this.store.dispatch(unconfirmItem({ id: this.id }));
  }
  showLogs() {
    const dialogRef = this.dialog.open(LogViewerDialogComponent, {
      width: '80%',
      height: '80%'
    });
  }

  promptDelete() {
    const dialogRef = this.dialog.open(DeleteDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      //  console.log("nwessssss", this.news);
      /*
            if (result) {
                this.newsService.deleteArticle(this.news.id).then(() => {
                    setTimeout(() => this.router.navigate(['/news']), 1000);
                })

            }
            */
      if (result) {
        this.store.dispatch(deleteItem({ id: this.news.id }));
        this.clearSub.next(null);
      }

      // TODO implement delete functionality
    });
  }

  public canBeClosed() {
    if (
      this.inputForm.controls.article_source.value ||
      this.inputForm.controls.article_title.value ||
      this.inputForm.controls.article_content.value
    ) {
      return false;
    }
    return true;
  }
}

@Component({
  selector: "delete-diag",
  template: `
    <div mat-dialog-content class="tw-m-3">
      <div>
        <p class="mat-h4">Do you really want to delete this entry?</p>
      </div>
      <div mat-dialog-actions class="tw-flex tw-justify-between">
        <button
          class="tw-rounded tw-bg-red-600 tw-text-white tw-border-none focus:tw-outline-none"
          (click)="onClick(true)"
        >
          Delete
        </button>
        <button
          class="tw-rounded tw-bg-neutral-500 tw-text-white tw-border-none focus:tw-outline-none"
          (click)="onClick(false)"
        >
          Cancel
        </button>
      </div>
    </div>
  `,
})
export class DeleteDialogComponent {
  factor;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DeleteDialogComponent>
  ) {}

  onClick(wantDeleted: boolean): void {
    this.dialogRef.close(wantDeleted);
  }
}
@Component({
  selector: 'app-updateandsave-dialog',
  template: `
    <div mat-dialog-content class="tw-m-6 tw-p-6 tw-bg-white tw-shadow-lg">
      <div class="tw-text-center tw-mb-6">
        <h2 class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ data.title || 'Save Options' }}</h2>
        <p class="tw-text-gray-600 tw-text-base tw-mt-2">{{ data.message || 'How would you like to proceed?' }}</p>
      </div>

      <div mat-dialog-actions class="tw-flex tw-flex-col tw-gap-4">
        <button
          color="accent"
          class="tw-py-3 tw-text-lg tw-font-semibold"
          (click)="dialogRef.close('saveAndTranslate')"
        >
          🌍 Save and Translate
        </button>

        <button
          color="primary"
          class="tw-py-3 tw-text-lg tw-font-semibold"
          (click)="dialogRef.close('saveOnly')"
        >
          💾 Save without Translation
        </button>

        <button
          mat-raised-button
          style="background-color: #e0e0e0;"
          class="tw-py-3 tw-text-lg tw-font-semibold"
          (click)="dialogRef.close('cancel')"
        >
          ❌ Cancel
        </button>
      </div>
    </div>
  `,
})
export class SaveTranslateDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SaveTranslateDialogComponent>
  ) {}

  onClick(saveAndTranslate: boolean): void {
    this.dialogRef.close(saveAndTranslate);
  }
}